import { ENDPOINTS } from '../common/endpoints';
import { baseAPI } from './BaseAPI';
import {CreateStockRequest, StockDto} from '../models/Items/IStock';
import { UNIT_OF_WEIGHT } from '@mybake/ui/common/dictionary';
import { TAGS } from './TagTypes';

export const stockAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({
        getStocksByItemId: build.query<StockDto[], string>({
            query: (itemId) => ({
                url: `${ENDPOINTS.STOCKS.V2_BY_ITEM}${itemId}`,
                method: 'GET',
                params: {limit: 50, includeDeleted: true},
            }),
            providesTags: (_result, _error, itemId) => [{type: 'Item', id: itemId}],
        }),

        getAllStocks: build.query<StockDto[], void>({
            query: () => ({url: ENDPOINTS.STOCKS.V2, method: 'GET'}),
            providesTags: [TAGS.ITEM],
        }),

        addStock: build.mutation<StockDto, {stock: CreateStockRequest; weightUnit: UNIT_OF_WEIGHT}>({
            query: ({stock, weightUnit}) => ({
                url: ENDPOINTS.STOCKS.V2,
                method: 'POST',
                body: stock,
                params: {weightUnit},
            }),
            invalidatesTags: (_result, _error, {stock}) => [
                TAGS.ITEM,
                {type: TAGS.ITEM, id: stock.itemId},
                TAGS.RECIPES,
                TAGS.RECIPE,
                TAGS.FILLINGS,
                TAGS.FILLING,
                TAGS.DECORATIONS,
                TAGS.DECORATION,
                TAGS.RECIPES_FOR_ORDER,
            ],
        }),
        fixStockWeight: build.mutation<StockDto, {stockId: string; correctWeight: number}>({
            query: ({stockId, correctWeight}) => ({
                url: `${ENDPOINTS.STOCKS.V2}/${stockId}/weight`,
                method: 'PATCH',
                params: {correctWeight},
            }),
            invalidatesTags: [TAGS.ITEM],
        }),
    }),
});
